export default __webpack_public_path__ + "images/221132b3f52aef8b95377f81a4ec9109.svg";